import {PropsWithChildren, MouseEvent} from 'react'
import {BaseComponent, BaseProps, BaseState} from '../BaseComponent'

export interface RadioButtonProps extends BaseProps {
    value: string | undefined,
    labelClassName?: 'btn btn-outline-primary',
    activeId?: string | undefined
}

interface RadioButtonState extends BaseState {
    forceRedraw: boolean
}

/**
 * gli attributi sicuramente gestiti -- quelli da non riscrivere
 */
const defaults : RadioButtonProps = {
    value: undefined,
    id: undefined,
    className: 'btn-check',
    labelClassName: 'btn btn-outline-primary',
    activeId: undefined,
    onClick: undefined,
    callback: undefined
}

class RadioButton extends BaseComponent<PropsWithChildren<RadioButtonProps>, RadioButtonState> {

    constructor (props: any) {
        super(props)

        this.state = {
            forceRedraw: false
        }

        this.mergedProps = { ...defaults, ...props} as RadioButtonProps

        this.onCLickHandler = this.onCLickHandler.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<PropsWithChildren<RadioButtonProps>>, prevState: Readonly<RadioButtonState>, snapshot?: any): void {
        if (prevProps.activeId !== this.props.activeId) {
            this.setState({ forceRedraw: ! this.state.forceRedraw })
        }
    }

    render() {
        // stabilisco la classe da dare al input
        let isActive : boolean = (
            this.props.id === this.props.activeId
        )
        
        let inputClassString = (this.props.className ?? '') + ' btn-check'
        let labelClassString = 'btn btn-outline-primary' + (isActive ? ' active' : '')

        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        const errorTag = this.getError()
        
        return (
            this.props.id &&
            <>
                <input 
                    id={this.props.id} key={this.props.id}
                    type="radio" 
                    className={inputClassString}
                    autoComplete="off"
                    value={this.props.value}
                    checked={isActive}
                    // riporto gli eventi a cui sono intressato
                    onClick={this.onCLickHandler}
                    onChange={this.onChangeHandler}
                    // stampo tutte le altre props
                    {...attributes}
                />
                <label 
                    key={this.props.id + '_label' }
                    className={labelClassString} 
                    htmlFor={`${this.props.id}`}
                >
                    {this.props?.label}
                </label>
                {errorTag !== undefined && errorTag}
            </>

        )
    }

    onChangeHandler () {
        return false
        // volgio che funzioni al clik non al change
    }

    onCLickHandler (e: MouseEvent<HTMLInputElement>) {
        e.stopPropagation()

        if (this.props.callback) {
            this.props.callback (
                this.props.id,
                this.props.value
            )
        }
    }
}

export default RadioButton